module.exports = __webpack_public_path__ + "static/media/Acuvue_DEFINE_Small_Color_6507-04.a523a8cc.png";